/**
 * Einheitliche Aktenzeichen-Generierung — Issue #826
 *
 * Früher: Client verwendete AK-Präfix, MCP-Tools verwendeten GK-Präfix.
 * Jetzt: Beide Pfade (UI und MCP/Agent) nutzen dieselbe Funktion mit GK-Präfix.
 *
 * Format: GK-{year}-{6digits} → 1.000.000 Kombinationen pro Jahr.
 * crypto.getRandomValues läuft sowohl im Browser als auch in Node.js 18+.
 */

export function generiereAktenNr(): string {
  const year = new Date().getFullYear();
  const buf = new Uint32Array(1);
  crypto.getRandomValues(buf);
  const suffix = String(buf[0] % 1_000_000).padStart(6, '0');
  return `GK-${year}-${suffix}`;
}
